import * as angular from "angular";

angular
  .module('bringoz.admin.billing-accounts')
  .constant('baDocumentTypes', [
    'Charge',
    'Refund',
    'Credit',
    'Debit',
    'Document'
  ])

